module.exports = __webpack_public_path__ + "static/media/indianbell.b81304a8.mp3";